import React, { Component } from "react";
// bootstrap imports
import Card from "react-bootstrap/Card";

/*
The component below displays the results after the user enters an amount and calculate function has been called
Using values passed through props from the converter component*/
export class Result extends Component {
  render() {
    return (
      <div className="result">
        {/* ternary to display results if the user has entered an amount */}
        {this.props.amount ? (
          <>
            <Card.Title>
              {this.props.amount} {this.props.base} is equivalent to
            </Card.Title>
            <Card.Title>
              {/* ternary to display results or calculating if there is no results yet */}
              {this.props.result === null
                ? "Calculating..."
                : this.props.result}
              {this.props.convertTo}
            </Card.Title>
            <Card.Title className="mb-3">As of {this.props.date}</Card.Title>
          </>
        ) : (
          <>
            <h3>ENTER A VALUE IN USD CONVERT TO ZAR/GBP/EUR</h3>
          </>
        )}
      </div>
    );
  }
}

export default Result;
